import { render, staticRenderFns } from "./CreateTicketByTech.vue?vue&type=template&id=6cfa2f11&"
import script from "./CreateTicketByTech.vue?vue&type=script&lang=js&"
export * from "./CreateTicketByTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports